import styled from 'styled-components';

export const Container = styled.div`
  margin: 48px 0;
`;
